import { type AccessRoute, ROUTE_ACCESS, type RouteAccess } from './route-access.js';

/** The route's own entry plus every ancestor entry, outermost first. */
export function accessRouteChain(route: AccessRoute): RouteAccess[] {
  const segments = route.split('/');
  const chain: RouteAccess[] = [];
  for (let length = 2; length <= segments.length; length += 1) {
    const prefix = segments.slice(0, length).join('/');
    if (Object.hasOwn(ROUTE_ACCESS, prefix)) chain.push(ROUTE_ACCESS[prefix as AccessRoute]);
  }
  return chain;
}
